
import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import Edit from './edit';
import save from './save';
import metadata from './block.json';
import icons from './icons.js';

registerBlockType(metadata.name, {
	icon: icons.keyConcept,
	category: 'custom-c4l-category',
	attributes: {
		content: {
			type: 'string',
		}
	},
	example: {
		attributes: {
			content: "Metabolism is the set of chemical reactions that occur in an organism to maintain life, enabling growth, reproduction, and response to the environment."
		}
	},
	edit: Edit,
	save,
});
